<template>
  <div>
    <v-combobox
      :label="customLabel"
      v-model="pickupPoint"
      :items="items"
      item-text="name"
      item-value="name"
      @blur="onBlur"
      @change="onChange"
      :outlined="outlined"
    ></v-combobox>
  </div>
</template>

<script>
import gql from "graphql-tag";
const query = gql`
  query pickupPoints($filter: PickupPointFilterType) {
    pickupPoints(filter: $filter) {
      edges {
        node {
          name
          isPickup
          isDropoff
        }
      }
    }
  }
`;
export default {
  name: "pickup-point-list-select",
  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    isDropoff: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      pickupPoint: this.value ? this.value : "",
    };
  },
  computed: {
    customLabel() {
      return this.label != "" ? this.label : "Pickup Point";
    },
    items() {
      return this.pickupPoints
        ? this.pickupPoints.edges.map((p) => ({ ...p.node }))
        : [];
    },
    filter() {
      return this.isDropoff ? { isDropoff: true } : { isPickup: true };
    },
  },
  watch: {
    value(newValue) {
      this.pickupPoint = newValue ? newValue : "";
    },
  },
  methods: {
    // http://tracker.globetrack.ie/issues/6034
    onBlur(event) {
      this.$emit("input", event.target.value);
    },
    onChange(event) {
      //console.log(event);
      //this.$emit("input", event.name);
    },
  },
  apollo: {
    pickupPoints: {
      query,
      variables() {
        return {
          filter: this.filter,
        };
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/PickupPointListSelect.vue